import React from 'react';
import { connect } from 'react-redux'
import {getNameByLabel,  getLastSectionPath} from '../../utils/emdUtil'
import { TEAMWORK, DCTERMS } from '../../const/C';
import WikiLink from '../wiki/WikiLink';
import Label from '../widgets/Label';
import Description from '../widgets/Description';

/**
 * Предоставление информации о связанные с объектами ЕМД элементами коллективной работы
 * Элементы фиксируются в аннотации к элементу. Пример задания в VOWL 
 * {
 *	"iri": "http://hbz.ru/ontologies/emd/KeyFamily#STAMM",
 *	"baseIri": "http://hbz.ru/ontologies/emd/KeyFamily",
 *	"label": {  "IRI-based": "STAMM", "undefined": "Количество выявленных резистентных штаммов"	},
 *	"annotations": {
 *		"type": [
 *			{ "identifier": "type", "type": "iri", "value": "http://www.w3.org/2002/07/owl#NamedIndividual", "language": "undefined"},
 *			{ "identifier": "type", "type": "iri", "value": "http://hbz.ru/ontologies/emd/Category", "language": "undefined"},
 *			{ "identifier": "type", "type": "iri", "value": "http://hbz.ru/ontologies/emd/KeyFamily", "language": "undefined" }
 *		],
 *		"topConceptOf": [
 *			{ "identifier": "topConceptOf", "type": "iri", "value": "http://hbz.ru/ontologies/emd/CategoryScheme#HBB", "language": "undefined"}
 *		],
 *		"inScheme": [
 *			{ "identifier": "inScheme", "type": "iri", "value": "http://hbz.ru/ontologies/emd/CategoryScheme#HBB", "language": "undefined" }
 *		],
		"Dimension": [
			{
				"identifier": "Dimension",
				"type": "anonymous",
				"value": "nodeID://b1270614",
				"language": "undefined",
				"label": { "IRI-based": "b1270614", "undefined": "Дата отчёта" },
				"annotations": {
					"labels": [
						{ "identifier": "label", "language": "undefined", "value": "Дата отчёта", "type": "label" }
					],
					"comments": [],
					"description": [],
					"deprecated": false,
					"identifierToAnnotation": []
				}
			},
			{
				"identifier": "Dimension",
				"type": "anonymous",
				"value": "nodeID://b1270615",
				"language": "undefined",
				"label": { "IRI-based": "b1270615", "undefined": "Организации"},
				"annotations": {
					"labels": [
						{ "identifier": "label", "language": "undefined", "value": "Организации", "type": "label"}
					],
					"comments": [],
					"description": [],
					"deprecated": false,
					"identifierToAnnotation": {
						"isDefinedBy": [
							{
								"identifier": "isDefinedBy",
								"type": "literal",
								"value": "http://62.61.8.56:8080/web/guest/adms#/adms/http%3A%2F%2Fcsi.semanticpro.org%2Fontologies%2F2016%2Fadms%23MicrobiologicalLaboratories",
								"language": "undefined"
							}
						],
						"semanticRelation": [
							{
								"identifier": "semanticRelation",
								"type": "iri",
								"value": "http://hbz.ru/ontologies/emd/Concept#ORGANIZATION",
								"language": "undefined"
							}
						],
						"wiki": [
							{
								"identifier": "wiki",
								"type": "literal",
								"value": "http://62.61.8.56:8080/web/guest/wiki/-/wiki/%D0%91%D0%B0%D0%B7%D0%BE%D0%B2%D1%8B%D0%B5+%D0%BC%D0%BE%D0%B4%D0%B5%D0%BB%D0%B8/vCard",
								"language": "undefined"
							}
						]
					}
				}
			}
		],
		"Measure": [
			{
				"identifier": "Measure",
				"type": "anonymous",
				"value": "nodeID://b1270616",
				"language": "undefined",
				"label": { "IRI-based": "b1270616", "undefined": "Количество выявленных резистентных штаммов" },
				"annotations": {
					"labels": [
						{ "identifier": "label", "language": "undefined", "value": "Количество выявленных резистентных штаммов", "type": "label" }
					],
					"comments": [],
					"description": [],
					"deprecated": false,
					"identifierToAnnotation": []
				}
			}
		]
	},
 *	"labels": { "IRI-based": "STAMM", "undefined": "Количество выявленных резистентных штаммов" }
 *}
 * 
 * Для более детальной информации передаётся список триплетов из объекта
 */

 /** Отображение информации о Wiki */
const Wiki = ({item}) => {
		const {value} = item;
		//Наименование определяем по значению до последнего слеша
		const name = decodeURIComponent(getLastSectionPath(value));
    return (<span><a target="_blank" href={value} ><b>{name}</b></a></span> )
}
 /** Отображение информации о Wiki */
 const WikiNoLink = ({item}) => {
	const {value} = item;
	//Наименование определяем по значению до последнего слеша
	const name = decodeURIComponent(getLastSectionPath(value));
	return (<span><b>{name}</b></span> )
}
/** Отображение информации о мастер данных в ADMS */
const ADMS = ({item}) => {
  const {value} = item;
  //Наименование определяем по значению до последнего слеша
  const name = getLastSectionPath(decodeURIComponent(getLastSectionPath(value)));
  return (
      <span><a target="_blank" href={value} ><b>{name}</b></a></span>
  )
}
/** Отображение информации о мастер данных в ADMS без ссылки */
const ADMSNoLink = ({item}) => {
  const {value} = item;
  //Наименование определяем по значению до последнего слеша
  const name = getLastSectionPath(decodeURIComponent(getLastSectionPath(value)));
  return ( <span><b>{name}</b></span> )
}
/** Отображение информации произвольной текстовой информации */
const Text = ({item}) => {
  const {value} = item;
  //Наименование определяем по значению до последнего слеша
  const name = getLastSectionPath(value);
  return (
      <span><b>{name}</b></span>
  )
}

const Data = ({data, components}) => {
  //console.log("const Data = ({data})", data, data.length);
  const identifier = (Array.isArray(data) && (data.length>0))? data[0].identifier: null;
  const showComponents = components.filter(item => item.identifier == identifier);
  const Component = (showComponents.length<1)? Text:  showComponents[0].component;
  //console.log("const Data = ({data})", showComponents, identifier, Component);
  return (<span>
    {data.map(item => <Component item={item}/> )}<br />
    </span>
  )
}

const Info = ({annotations, components}) => {
  const {identifierToAnnotation} = annotations;
  if (!identifierToAnnotation)
    return <span></span>;
  const keys = Object.keys(identifierToAnnotation);
  return (
    <div>
      {keys.map((key, i)=> <span key={i}>{'\u00A0'}{'\u00A0'}
        <i>{getProperty(key)}</i>: <Data data={identifierToAnnotation[key]} components={components}/><br />
        <Info annotations={identifierToAnnotation[key]} components={components}/>
      </span>)}
    </div>
	)
}

const identifiersProperties = ["Measure","MeasureProperty", "Dimension", "DimensionProperty", "TimeDimension", "TimeDimensionProperty"];
const detailSettings = [
  {topic: "Мера", identifier: "Measure", component: Info}, 
  {topic: "Мера", identifier: "MeasureProperty", component: Info}, 
  {topic: "Измерение", identifier: "Dimension", component: Info}, 
  {topic: "Измерение", identifier: "DimensionProperty", component: Info}, 
  {topic: "Измерение времени", identifier: "TimeDimension", component: Info}, 
  {topic: "Измерение времени", identifier: "TimeDimensionProperty", component: Info}, 
  {topic: "Дополнительная информация", identifier: "isDefinedBy", component: ADMS}, 
  {topic: "Wiki статья", identifier: "wiki", component: Wiki},
  {topic: "На основе элемента", identifier: "semanticRelation", component: Text}
];
const detailSettingsNoLink = [
  {topic: "Мера", identifier: "Measure", component: Info}, 
  {topic: "Мера", identifier: "MeasureProperty", component: Info}, 
  {topic: "Измерение", identifier: "Dimension", component: Info}, 
  {topic: "Измерение", identifier: "DimensionProperty", component: Info}, 
  {topic: "Измерение времени", identifier: "TimeDimension", component: Info}, 
  {topic: "Измерение времени", identifier: "TimeDimensionProperty", component: Info}, 
  {topic: "Дополнительная информация", identifier: "isDefinedBy", component: ADMSNoLink}, 
  {topic: "Wiki статья", identifier: "wiki", component: WikiNoLink},
  {topic: "На основе элемента", identifier: "semanticRelation", component: Text}
];

/** Определим аннотации, которые содержат информацию о связях элемента ЕМД с измерениями, мерами */
const getProperties = item => {
  const keys = Object.keys(item.annotations);
  const result = [];
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    if (identifiersProperties.includes(key)){
      result.push(item.annotations[key]);
    }    
  }
	console.log("popUpInfo.js getProperties(item)", item, result);
  return result;
}

const getProperty = identifier =>{
  const item = detailSettings.filter(item => item.identifier == identifier);
  if (item.length==0) return "Свойство"
  return item[0].topic;
}


const Details = ({item, components}) => {
  //Наименование определяем по значению до последнего слеша
  const topicId = (item.length>0)?item[0].identifier: "???";
  let topicName = getProperty(topicId);
  return (
    <div>
      {(item.length>0) && (<b>{topicName}<br /></b>)}
      {item.map((d, i)=> <span key={i}>
        <u>Наименование:</u> {getNameByLabel(d.annotations)}<br />
        <Info annotations={d.annotations} components={components}/>
      </span>)}
    </div>
	)
}

const DescriptionSection = ({description}) => {
	return (
		<span>
			<h3>Описание</h3>
			<Description />
		</span>
	)
}

const SubClassOf = ({subClassOf}) => {
	return (
		<span>
			<h3>Родительские элементы</h3>
			<ul style={{listStyle: "square"}}>
				{subClassOf.map((subClass, i)=> <li key={i}><Label iri={subClass.o.value}/></li>)}
			</ul>
		</span>
	)
}
//{decodeURIComponent(getLastSectionPath(subClass.o.value))}
/**
 * Основная компонента отображение информации о элементе 
 */
class InfoElement extends React.Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            loading: false, 			//Флаг загрузки
        }
    }

    render() {
				//console.log(this);console.log(JSON.stringify(this.props.triplets)); 
				const {item} = this.props.selected;
				const hasWiki = (Array.isArray(this.props.wikies))?this.props.wikies.length>0 : false;
				const hasOwners = (Array.isArray(this.props.subClassOf))?this.props.subClassOf.length>0: false;
				const wikies = this.props.wikies;
				const details = getProperties(item);
				const components = (this.props.noLinks)? detailSettingsNoLink: detailSettings;
        return (
            <div>
							<h3>IRI</h3><p>{item.iri}</p>
							<h3>Наименование</h3><p>{this.props.selected.name}</p>
							{hasWiki && <h3>Wiki статьи</h3>}
							{hasWiki && (
									<ul style={{listStyle: "square"}}>
										{wikies.map((wiki, i)=> <li key={i}><WikiLink wiki={wiki.o.value} triplet={wiki} content={this.props.content}/></li>)}
									</ul>
							)}
							{hasOwners && <SubClassOf  subClassOf={this.props.subClassOf} />}
								{(details.length>0)&&(
									<p><i>Свойство:</i>
											<ul style={{listStyle: "square"}}>
													{details.map((d, i)=> <li key={i}><Details item={d} components={components}/></li>)}
											</ul>
									</p>
								)}
            </div>
        );
    }
};

export default connect(
	(state, props) => {
		const {selected, content} = props;
		const iri = (selected && selected.item)?selected.item.iri: null;
		//Список триплетов
		const triplets =  (content && content.results && Array.isArray(content.results.bindings) && iri)
			? content.results.bindings.filter(item => (item.s.value == iri)):[];	
		//Связанные wiki статьи
		const wikies = triplets.filter(item => (item.p.value == TEAMWORK.PREDICAT_WIKI));	
		//Родительские классы: "http://www.w3.org/2000/01/rdf-schema#subClassOf"
		const subClassOf = triplets.filter(item => (item.p.value == "http://www.w3.org/2000/01/rdf-schema#subClassOf"));	
    return ({
			iri, wikies, triplets, subClassOf
    })
  },
	null
)(InfoElement);
